import React, {
  memo, useEffect, useRef, useState
} from 'react';
import PropTypes from 'prop-types';

import { getResourceTo } from 'react/utils/utils';
import ChevronIcon from 'static/images/sidebar/chevron-down.svg';
import SingleMenuItem from './SingleMenuItem';
import { getClusterMenusName } from './utils';
import { usePin } from 'react/hooks/sidebar.hook';

function renderPanelBuilderSeparator(isFirstPanel) {
  return isFirstPanel ? (
    <p className="text-separator">
      {getResourceTo('greenmile.panelbuilder.listtile')}
    </p>
  ) : (
    <> </>
  );
}

function SubMenuItem({
  url,
  name,
  submenus,
  external,
  panel,
  isFirstPanel
}) {
  const { pinnedMenus } = usePin();
  const [dropDownIsOpen, setDropDownIsOpen] = useState(false);

  const dropDownRef = useRef(null);
  const menuItemRef = useRef(null);

  function renderSeparatorMenus(clusterMenuName) {
    const separatorText = getClusterMenusName(clusterMenuName);

    if (separatorText) {
      return (
        <p className="text-separator">{separatorText}</p>
      );
    }

    return null;
  }

  useEffect(() => {
    if (dropDownIsOpen) {
      let updatedDropDownTop = 0;
      const extraGap = 60;
      const { top } = menuItemRef.current.getBoundingClientRect();

      const dropDownHeight = dropDownRef.current.offsetHeight;
      const totalHeight = top + dropDownHeight;

      if (totalHeight > window.innerHeight) {
        updatedDropDownTop = top - dropDownHeight;
      } else {
        updatedDropDownTop = top - extraGap;
      }

      dropDownRef.current.style.top = `${updatedDropDownTop}px`;
    }
  }, [dropDownIsOpen, pinnedMenus.length]);

  if (submenus?.length) {
    return (
      <>
        {renderSeparatorMenus(name)}
        <div
          ref={menuItemRef}
          onMouseEnter={() => setDropDownIsOpen(true)}
          onMouseLeave={() => setDropDownIsOpen(false)}
          className={`menu-with-submenu-content  ${dropDownIsOpen ? 'dropdown-open' : ''}`}
          data-testid={`menu-with-submenu-content-${name}`}
        >
          <span>
            {getResourceTo(name)}
          </span>
          <img
            src={ChevronIcon}
            alt="Chevron Icon"
          />
          {dropDownIsOpen && (
            <ul
              ref={dropDownRef}
              className="grandchild-menus"
              data-testid={`grandchild-menus-${name}`}
            >
              {submenus.map((item) => (
                <SingleMenuItem
                  key={item.name}
                  external={item.external}
                  url={item.url}
                  name={item.name}
                  panel={item.panel}
                />
              ))}
            </ul>
          )}
        </div>
      </>
    );
  }

  return (
    <>
      {renderPanelBuilderSeparator(isFirstPanel)}
      {renderSeparatorMenus(name)}
      <SingleMenuItem
        external={external}
        url={url}
        name={name}
        panel={panel}
      />
    </>
  );
}

SubMenuItem.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  external: PropTypes.bool,
  submenus: PropTypes.array,
  panel: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isFirstPanel: PropTypes.bool
};

SubMenuItem.defaultProps = {
  external: false,
  submenus: [],
  panel: false,
  isFirstPanel: false
};

export default memo(SubMenuItem);
